import React, { useEffect, useState } from "react";
import { Mensaje } from "../../mensajes2";
import axios from "axios";
import { Dimmer } from "../../spinner";
import useTableR from "../../useTableR";
import { formatMoneda } from "../../../util/varios";
import { Radio } from "../../../ui/inputs/Input"; // 👈 NUEVO

const TablaDeudasVehiculos = (props) => {
  const espiritu = localStorage.getItem("espiritu");
  const fechaSistema = localStorage.getItem("fechasistema");
  const token = localStorage.getItem("jwtToken");
  const op = require("../../../modulos/datos");

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);

  // 👇 NUEVO: en este módulo el factor llega como objeto { valor: X }
  //    (por props o por localStorage), se protege para evitar dividir entre 0/undefined
  const factorObj =
    props.factorCambio ?? JSON.parse(localStorage.getItem("factorCambio"));
  const factorValor = factorObj?.valor; // valor crudo (para el guard del fetch)
  const factorCambio = Number(factorValor) || 1; // factor numérico seguro

  // 1 = Monto en Bs. / 0 = Monto en U.C
  const [moneda, setMoneda] = useState(1);

  const [montos, setMontos] = useState({
    deuda: 0,
    interes: 0,
    recargo: 0,
    totalDeuda: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const headCells = [
    {
      id: "anio",
      label: "AÑO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "mes",
      label: "MES",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "monto",
      label: "MONTO",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "intereses",
      label: "INTERES MORA",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "recargo",
      label: "RECARGOS",
      width: "150px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableR(records, headCells, filterFn);

  // ================= LÓGICA DE CONVERSIÓN (igual que TablaDeudasEjidos) =================

  // 👇 NUEVO: convierte strings "1234,56" o números a float de forma segura
  const aNumero = (valor) =>
    parseFloat(String(valor ?? 0).replace(",", ".")) || 0;

  // 👇 NUEVO: ¿está marcado el radio "Monto en U.C"? (value = 0)
  const esUc = Number(moneda) === 0;

  // 👇 NUEVO: U.C -> divide entre el factor de cambio | Bs -> valor normal
  const convertir = (valor) => {
    const num = aNumero(valor);
    return esUc ? num / factorCambio : num;
  };

  // 👇 NUEVO: convierte y formatea con 2 decimales
  const fmt = (valor) =>
    formatMoneda(convertir(valor).toFixed(2).replace(".", ","), ",", ".", 2);

  // 👇 NUEVO: suma los valores CRUDOS (sin convertir) y al final aplica la conversión
  const calcularTotales = (lista) => {
    let deu = 0;
    let inte = 0;
    let reca = 0;
    let desc = 0;

    (lista || []).forEach((item) => {
      deu += aNumero(item.monto);
      inte += aNumero(item.intereses);
      reca += aNumero(item.recargo);
      desc += aNumero(item.descuento);
    });

    setMontos({
      deuda: fmt(deu),
      interes: fmt(inte),
      recargo: fmt(reca),
      totalDeuda: fmt(deu + inte + reca - desc), // igual que antes: resta el descuento
    });
  };

  // 👇 NUEVO: los totales se recalculan solos cuando cambian los datos
  //    o cuando se cambia el radio entre Bs y U.C
  useEffect(() => {
    calcularTotales(records);
  }, [records, moneda]);

  // =======================================================================================

  const buscarDeudasVehiculos = async (idVehiculo) => {
    try {
      setLoading(true);
      const endpoint = `${op.conexion}/api/vehiculo/deudavehiculo?idvehiculo=${idVehiculo}&fecha=${fechaSistema}&espiritu=${espiritu}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        // 👇 CAMBIADO: solo se guardan los datos CRUDOS, sin sumar ni formatear.
        //    La conversión y los totales los hace el useEffect de arriba.
        const datosProcesados = response.data
          .filter((item) => item.fechapago === null)
          .map((item) => ({
            anio: item.anio,
            mes: item.mes.replace(/'/g, ""),
            monto: item.mondeu,
            intereses: item.intmoradeu,
            recargo: item.recargodeu,
            descuento: item.mondescue,
            totalperi: item.subtotal,
            status: item.estatus,
            idfac: item.idfact,
            nummes: item.nmes,
            estatusfac: item.estatusfac,
            tipotransaccion: item.tipotransaccion,
          }));

        setRecords(datosProcesados); // 👈 el useEffect recalcula los montos solo
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar las Deudas del Vehiculo",
        icono: "error",
      });
    } finally {
      props?.setRefreshDeuda(false);
      setLoading(false);
    }
  };

  const imprimirDeuda = () => {
    const id = "VEH.IdVehiculo=" + parseInt(props.idVehiculo);
    window.open(
      op.reportes +
        "/impuestovehiculo?" +
        "reporte=EdoCtaCorto2Vehic" +
        "&sql=" +
        id +
        "&valpetro=" +
        factorCambio +
        "&radioBolivares=" +
        moneda, // 👈 CAMBIADO: 1 = Bs / 0 = U.C (antes iba fijo en 1)
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  // 👇 NUEVO: handler de los radios (igual que en Ejidos)
  const renderDeuda = (e) => {
    const { value } = e.target;
    setMoneda(value); // 👈 con esto solo, la tabla y los totales ya se convierten
  };

  useEffect(() => {
    if (props.idVehiculo && factorValor) {
      buscarDeudasVehiculos(props.idVehiculo);
    }
  }, [props.idVehiculo, props.refreshDeuda, factorValor]);

  return (
    <div className="card">
      <div className="card-body" style={{ height: "100%" }}>
        <div className="content mx-auto">
          <div className="container mx-auto">
            <div className="row col-md-12 mx-auto" style={{ height: "100%" }}>
              <div className="row mx-auto">
                {/* 👇 NUEVO: radios de moneda (Bs / U.C) igual que en Ejidos */}
                <div className="col-md-12 d-flex justify-content-between mb-2">
                  <div className="col-auto m-0 p-0 d-flex gap-2 align-items-start">
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Monto en Bs."
                        onChange={renderDeuda}
                        value={1}
                        name="montoVeh"
                        id="montoBsVeh"
                        defaultChecked
                      />
                    </div>
                    <div className="col-auto m-0 p-0">
                      <Radio
                        label="Monto en U.C"
                        onChange={renderDeuda}
                        value={0}
                        name="montoVeh"
                        id="montoUcVeh"
                      />
                    </div>
                  </div>
                  <button
                    style={{ height: "30px" }}
                    onClick={() => imprimirDeuda()}
                    className="btn btn-sm btn-primary rounded-circle"
                  >
                    <i className="fas fa-print"></i>{" "}
                  </button>
                </div>
                <div className="col-md-12 mx-auto px-0">
                  <TblContainer
                    container={{
                      width: "100%",
                      overflow: "auto",
                      padding: "2px",
                    }}
                  >
                    <TblHead />

                    <tbody>
                      {records &&
                        recordsAfterPagingAndSorting().map((item, index) => (
                          <tr key={index} style={{ padding: "0" }}>
                            <td style={{ fontSize: "10px", textAlign: "left" }}>
                              {item.anio}
                            </td>
                            <td style={{ fontSize: "10px", textAlign: "left" }}>
                              {item.mes}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {fmt(item.monto)} {/* 👈 CAMBIADO */}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {fmt(item.intereses)} {/* 👈 CAMBIADO */}
                            </td>
                            <td
                              style={{ fontSize: "10px", textAlign: "right" }}
                            >
                              {fmt(item.recargo)} {/* 👈 CAMBIADO */}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </TblContainer>
                  <TblPagination />
                  <div className="col-md-12 mx-auto row px-0 border-table">
                    <div className="col-md-8 row mx-auto"></div>
                    <div className="col-md-4 row">
                      <div class="input-group input-group-sm mb-0 col-md-12">
                        <span
                          class="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Deuda:
                        </span>
                        <input
                          type="text"
                          class="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          value={montos.deuda}
                        />
                      </div>

                      <div class="input-group input-group-sm mb-0 col-md-12">
                        <span
                          class="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Intereses de Mora:
                        </span>
                        <input
                          type="text"
                          class="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          value={montos.interes}
                        />
                      </div>

                      <div class="input-group input-group-sm mb-0 col-md-12">
                        <span
                          class="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Recargo por Mora:
                        </span>
                        <input
                          type="text"
                          class="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          value={montos.recargo}
                        />
                      </div>

                      <div class="input-group input-group-sm mb-0 col-md-12">
                        <span
                          class="input-group-text bg-transparent border-0"
                          id="inputGroup-sizing-sm"
                        >
                          Total de la Deuda:
                        </span>
                        <input
                          type="text"
                          class="form-control text-right bg-transparent border-0"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          value={montos.totalDeuda}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <Dimmer active={loading} inverted />
    </div>
  );
};

export default TablaDeudasVehiculos;
